import { Suspense, useState } from 'react';
import { Plus } from 'lucide-react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProjectsList from '@pages/common/Project/Components/ProjectsList';
import { PageHeader } from '@components/PageHeader';

const ProjectsHeader = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleCreateProject = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        eyebrow="Research operations"
        title="Projects"
        description="Manage the clinical workspaces that group experiments, samples, and their associated analysis pipelines."
        actions={
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleCreateProject}
            variant="contained"
            startIcon={<Plus size={17} />}
          >
            Create Project
          </Button>
        }
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => navigate('create')}>Standard project</MenuItem>
        <MenuItem onClick={() => navigate('/batch')}>Batch project</MenuItem>
      </Menu>
    </>
  );
};

const Projects = () => (
  <main style={{ width: '100%', maxWidth: '1600px', margin: '0 auto' }}>
    <ProjectsHeader />
    <Suspense fallback={<div>Loading...</div>}>
      <ProjectsList />
    </Suspense>
  </main>
);

export default Projects;
